var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.259,
    height: 19.757,
    viewBox: "0 0 23.259 19.757",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-edit",
    "data-name": "Icon awesome-edit",
    d: "M16.257,3.214,19.9,6.7a.366.366,0,0,1,0,.533L11.08,15.658l-3.747.4a.769.769,0,0,1-.868-.83l.416-3.582L15.7,3.214A.408.408,0,0,1,16.257,3.214ZM22.8,2.33,20.828.447a1.631,1.631,0,0,0-2.229,0L17.169,1.813a.366.366,0,0,0,0,.533l3.642,3.481a.408.408,0,0,0,.557,0L22.8,4.461a1.463,1.463,0,0,0,0-2.13ZM15.506,13.365v3.929H2.584V4.943h9.279a.509.509,0,0,0,.343-.135l1.615-1.544a.461.461,0,0,0-.343-.791H1.938A1.9,1.9,0,0,0,0,4.326V17.911a1.9,1.9,0,0,0,1.938,1.853H16.152a1.9,1.9,0,0,0,1.938-1.853v-6.09a.489.489,0,0,0-.828-.328l-1.615,1.544A.464.464,0,0,0,15.506,13.365Z",
    transform: "translate(0 -0.007)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconWhite);
export default __webpack_public_path__ + "static/media/edit-icon-white.149c3239a8fff8fbabc02bf6296195b1.svg";
export { ForwardRef as ReactComponent };